import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { downloadBlob } from 'src/app/core/adapters/download-blob.adapter'
import { fundUpdatesKeys } from 'src/app/home/queries/keys'

export interface IUseFundUpdateDownloadQueryParams {
  documentUrl: string
  enabled: boolean
}

export const useFundUpdateDownloadQuery = (
  params: IUseFundUpdateDownloadQueryParams,
): UseQueryResult<Blob, Error> => {
  return useQuery({
    queryKey: fundUpdatesKeys.download(params.documentUrl),
    queryFn: () => downloadBlob(params.documentUrl),
    enabled: params.enabled,
    staleTime: Infinity,
    gcTime: 5 * 60 * 1000,
  })
}
